module.exports = __webpack_public_path__ + "29e7ee230a55b218e6a8de7f6807c9e4.woff";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/ComicNeue/ComicNeue-Angular-Light-Oblique.woff
// module id = 396
// module chunks = 0